<template>
  <div
    :class="[
      'bto-sb-history-title',
      { 'bto-sb-collapsed': type !== 'checker', 'bto-sb-show': type !== 'checker' && isOpened },
    ]">
    <div class="bto-sb-history-details">
      <div class="bto-sb-history-details-type">
        <span class="bto-sb-history-type">
          {{ bet.stake | formatAmountDisplay }} {{ t(bet.betSlipGroupType) }} ({{ bet.eventCount }})
        </span>
        <span class="bto-sb-history-code"> {{ t("BetSlip.ID") }}: {{ bet.betSlipGroupID }}</span>
        <span class="bto-sb-history-builder" v-if="displayBetBuilderIcon">
          <i class="bto-app-betbuilder"></i> {{ t("BetSlipMatchType.BB") }}
        </span>
        <span class="bto-sb-history-date">{{ bet.createdOn }}</span>
      </div>
      <div class="bto-sb-history-more-info" v-if="!isOpened">
        <div
          v-for="(match, idx) in bet.betslipDetailsMatches"
          :key="idx"
          class="bto-sb-history-event">
          {{ generateMatchTitle(match) }}
          <template v-if="isMatchBetBuilder(match) || isMatchAlgoBetbuilder(match)">
            <div
              v-for="(outcome, idx) in generateBetBuilderOutcomes(match.betBuilderMarket)"
              :key="idx"
              class="bto-sb-history-event-outcome">
              <span class="bto-sb-history-event-outcome">
                {{ outcome }}
              </span>
            </div>
          </template>
          <template v-else-if="isMatchBoostedOdds(match)">
            <div class="bto-sb-history-event-outcome">
              <span class="bto-sb-history-event-outcome">
                {{ match.marketName }}
              </span>
            </div>
          </template>
          <template v-else>
            <div class="bto-sb-history-event-outcome">
              <span class="bto-sb-mb-history-event-market">{{ match.marketName }} :</span>
              <span class="bto-sb-history-event-outcome"> {{ match.outcomeName }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="bto-sb-history-info">
      <div
        class="bto-sb-history-cashoutaction"
        v-if="type === 'history' && showCashout && !isOpened">
        <a
          v-if="cashoutCircularLoader"
          :class="[
            'bto-sb-form-btn bto-sb-btn-cashout',
            { 'bto-sb-loader': cashoutCircularLoader === true },
          ]"
          ><i class="bto-sb-spinner-v1"></i>{{ t("Mobile.CashingOut") }}
        </a>
        <span
          v-else-if="
            cashoutCircularLoader === false &&
            cashoutNewOffer === 0 &&
            (cashoutStep === 3 || cashoutStep === 2)
          "
          class="bto-sb-form-btn bto-sb-btn-suspended">
          {{ t("M.CashoutSuspended") }}
        </span>
        <a
          v-else-if="cashoutCircularLoader === false && cashoutVal > 0"
          :class="[
            'bto-sb-form-btn bto-sb-btn-cashout',
            {
              'bto-sb-btn-cashoutconfirm':
                cashoutCircularLoader === false && (cashoutStep === 1 || cashoutStep === 2),
            },
          ]"
          @click.stop="processCashout(cashoutVal)">
          <span :class="{ 'bto-app-icon bto-app-check': cashoutStep === 4 }"></span>
          {{ cashoutBtnName }} {{ cashoutVal | formatAmountDisplay }}
        </a>
        <a
          v-if="cashoutCircularLoader === false && (cashoutStep === 1 || cashoutStep === 2)"
          class="bto-sb-form-btn bto-sb-form-btn-delete"
          @click.stop="cancelCashout()">
          <i class="bto-app-delete"></i>
        </a>
      </div>
      <span
        class="bto-sb-history-event-status"
        :class="getStatusClass(bet)"
        v-if="type !== 'negotiation'">
        {{ t(bet.betSlipGroupStatus || "") }}
        {{ generateAmountText(bet) }}
      </span>
      <div class="bto-sb-history-info" v-if="type === 'negotiation'">
        <span class="bto-sb-history-timeout">
          <i>{{ t("Negotiate.Timeout") }} </i>
          <i>{{ timer }}</i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { genereteTimeText } from '@/services/utils';
  import { formatCurrency } from '@bto-services/utils';
  import base from './base';
  import {
    MYBETS_STATUS_HISTORY_CLASS,
    MYBETS_STATUS_MOBILE_TEXT,
    MYBETS_SHOW_WON_STATUSES,
  } from '../../../../models/enums/mybets-const';
  import { ITEM_TYPES } from 'bto-models/betslip';
  import { checkLayout } from 'bto-models/app-settings/web';

  export default {
    name: 'MyBetsInlineHeader',
    extends: base,
    props: {
      type: {
        type: String,
        default: 'history',
      },
      isOpened: {
        type: Boolean,
        default: false,
      },
      timer: {
        type: String,
        required: false,
      },
    },
    data() {
      return {
        IS_US_LAYOUT: checkLayout('US'),
        showBetBuilder: APP_SETTINGS.myBets.showBetBuilder || false,
      };
    },
    methods: {
      getStatusClass(bet) {
        return MYBETS_STATUS_HISTORY_CLASS[bet.betSlipGroupStatusId] || '';
      },
      isMatchBetBuilder(match) {
        return match.itemType === ITEM_TYPES.BET_BUILDER;
      },
      isMatchBoostedOdds(match) {
        return match.itemType === ITEM_TYPES.BOOSTED_ODD;
      },
      isMatchAlgoBetbuilder(match) {
        return match.itemType === ITEM_TYPES.ALGO;
      },
      getStatusText(bet, statusMap) {
        let amount = statusMap.showAmount
          ? ` ${this.$betslipService.formatAmount(bet.winnings)}`
          : '';
        return `${this.$translate.text(statusMap.status)}${amount}`;
      },
      generateStatusText(bet) {
        return MYBETS_STATUS_MOBILE_TEXT[bet.betSlipGroupStatusId]
          ? this.getStatusText(bet, MYBETS_STATUS_MOBILE_TEXT[bet.betSlipGroupStatusId])
          : this.$translate.text(bet.betSlipGroupStatus);
      },
      generateAmountText(bet) {
        if (MYBETS_SHOW_WON_STATUSES.includes(bet.betSlipGroupStatusId) && this.cashoutAmount)
          return formatCurrency(this.cashoutAmount, bet.currencyCode);

        return MYBETS_SHOW_WON_STATUSES.includes(bet.betSlipGroupStatusId)
          ? formatCurrency(bet.winnings, bet.currencyCode)
          : '';
      },
      generateMatchTitle(match) {
        if (match.isUsLayout && this.IS_US_LAYOUT && match.awayTeam && match.homeTeam) {
          return `${match.awayTeam} @ ${match.homeTeam}`;
        }

        return match.eventName;
      },
      generateBetBuilderOutcomes(outcomeName) {
        return outcomeName.replace(/\s-\s/g, ' : ').split(',');
      },
      genereteTimeText,
    },
    computed: {
      displayBetBuilderIcon() {
        const { hasBetBuilderEvents } = this.bet;

        return this.showBetBuilder && hasBetBuilderEvents;
      },
    },
  };
</script>